<template>
  <v-card class="ma-2">
    <v-toolbar dense>
      <v-toolbar-title v-if="mode == 'new'">Nova Chave</v-toolbar-title>
      <v-toolbar-title v-if="mode == 'show'">Detalhes</v-toolbar-title>
      <v-toolbar-title v-if="mode == 'edit'">Editar</v-toolbar-title>
      <v-spacer />
      <v-btn
        class="mr-1"
        v-if="mode !== 'show' && remoteDTO.referencePlan"
        small
        @click="save"
      >
        <v-icon small title="Create">fas fa-save</v-icon>
      </v-btn>
      <v-btn class="mr-1" v-if="mode === 'show'" small @click="remove">
        <v-icon small title="Remover">fas fa-trash</v-icon>
      </v-btn>
      <v-btn v-if="mode === 'show'" small @click="edit">
        <v-icon small title="Editar">fas fa-edit</v-icon>
      </v-btn>
      <v-btn
        small
        @click="
          $router.go(-1);
          mode = 'show';
        "
      >
        <v-icon small title="Voltar">fas fa-arrow-circle-left</v-icon>
      </v-btn>
    </v-toolbar>
    <v-alert v-if="error" type="error" class="ma-8">
      {{ error }}
    </v-alert>
    <v-form ref="form" lazy-validation class="ma-4">
      <v-row dense align="center">
        <v-col cols="6">
          <ModeOtions
            :items="['Novo', 'Cópia', 'Herança']"
            :value="formModel.mode"
            @changed="setMode"
            :readonly="mode === 'show'"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="2">
          <SelectPlan
            label="Atual"
            @selected="setCurrentPlan"
            :value="remoteDTO.currentPlan"
            :errorMessages="formModel.errors.currentPlanId"
            :readonly="mode === 'show'"
          />
        </v-col>
        <v-col cols="2">
          <SelectPlan
            label="Referência"
            :readonly="true"
            :value="remoteDTO.referencePlan"
            :errorMessages="formModel.errors.referencePlanId"
          />
        </v-col>

        <v-col cols="2">
          <SelectPlan
            label="1° Proposto"
            @selected="setProposalPlanOne"
            :value="
              remoteDTO.proposalPlanOne ? remoteDTO.proposalPlanOne.plan : null
            "
            :errorMessages="formModel.errors.proposalPlanOne"
            :readonly="mode === 'show'"
          />
        </v-col>
        <v-col cols="2">
          <SelectPlan
            label="2° Proposto"
            @selected="setProposalPlanTwo"
            :value="
              remoteDTO.proposalPlanTwo ? remoteDTO.proposalPlanTwo.plan : null
            "
            :errorMessages="formModel.errors.proposalPlanTwo"
            :readonly="mode === 'show'"
          />
        </v-col>
        <v-col cols="2">
          <SelectPlan
            label="3° Proposto"
            @selected="setProposalPlanThree"
            :value="
              remoteDTO.proposalPlanThree
                ? remoteDTO.proposalPlanThree.plan
                : null
            "
            :errorMessages="formModel.errors.proposalPlanThree"
            :readonly="mode === 'show'"
          />
        </v-col>
        <v-col cols="2">
          <SelectPlan
            label="4° Proposto"
            @selected="setProposalPlanFour"
            :value="
              remoteDTO.proposalPlanFour
                ? remoteDTO.proposalPlanFour.plan
                : null
            "
            :errorMessages="formModel.errors.proposalPlanFour"
            :readonly="mode === 'show'"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="2">
          <SelectPlan
            label="5° Proposto"
            @selected="setProposalPlanFive"
            :value="
              remoteDTO.proposalPlanFive
                ? remoteDTO.proposalPlanFive.plan
                : null
            "
            :errorMessages="formModel.errors.proposalPlanFive"
            :readonly="mode === 'show'"
          />
        </v-col>
        <v-col cols="2">
          <DateField
            label="Iníco"
            @change="setStarAt"
            :errorMessages="formModel.errors.startAt"
            :readonly="mode === 'show'"
            :value="remoteDTO.startAt"
          />
        </v-col>
        <v-col cols="2">
          <DateField
            label="Fim"
            @change="setEndAt"
            :errorMessages="formModel.errors.endAt"
            :readonly="mode === 'show'"
            :value="remoteDTO.endAt"
          />
        </v-col>
        <v-col cols="1">
          <v-checkbox
            dense
            outlined
            v-model="remoteDTO.active"
            :false-value="false"
            :true-value="true"
            label="Ativo"
            :readonly="mode === 'show'"
          />
        </v-col>
      </v-row>
      <v-row
        dense
        v-if="formModel.mode == 'Cópia' || formModel.mode == 'Herança'"
      >
        <v-col cols="12">
          <SelectParent
            :equivalenceId = "remoteDTO.id"
            :referencePlan="remoteDTO.referencePlan"
            :parentPlan="formModel.parentPlan"
            :label="'Chave ' + formModel.mode"
            @selected="setParentId"
            :errorMessages="formModel.errors.parentPlan"
          />
        </v-col>
      </v-row>
    </v-form>
    <DlgConfirmCancel ref="confirm"></DlgConfirmCancel>
  </v-card>
</template>

<script>
import {mapMutations} from 'vuex';
import {mapFieldErrors} from '@/common/validation';
import EquivalenceConfigurationService from '@/services/insurancepricing/EquivalenceConfigurationService';
import ProductService from '@/services/odoo/ProductService';

import SelectPlan from '@/view/equivalence_configuration/components/select_plan';
import SelectParent from '@/view/equivalence_configuration/components/select_parent';
import DateField from '@/view/equivalence_configuration/components/date_field';
import ModeOtions from '@/view/equivalence_configuration/components/mode_options';
import DlgConfirmCancel from '@/components/dlg-confirm_cancel.vue';

const service = new EquivalenceConfigurationService();
const productService = new ProductService();

export default {
  components: {
    SelectPlan,
    SelectParent,
    DateField,
    ModeOtions,
    DlgConfirmCancel,
  },

  data() {
    return {
      formModel: {
        mode: 'Novo',
        errors: {},
        parentPlan: null,
      },
      remoteDTO: {
        id: null,
        startAt: null,
        endAt: null,
        active: true,
        referencePlan: {},
        currentPlan: {},
        parentId: null,
        proposalPlanOne: {plan: {}},
        proposalPlanTwo: {plan: {}},
        proposalPlanThree: {plan: {}},
        proposalPlanFour: {plan: {}},
        proposalPlanFive: {plan: {}},
      },
      mode: null,
      error: null,
    };
  },

  computed: {},

  methods: {
    ...mapMutations(['toogleDialogLoading']),

    // ---- Setters ----
    setStarAt(value) {
      this.remoteDTO.startAt = value;
    },

    setEndAt(value) {
      this.remoteDTO.endAt = value;
    },

    setCurrentPlan(value) {
      this.remoteDTO.currentPlan = value;
      this.formModel.errors.currentPlan = null;
    },

    setProposalPlanOne(value) {
      if (!this.remoteDTO.proposalPlanOne)
        this.remoteDTO.proposalPlanOne = {plan: value};
      else this.remoteDTO.proposalPlanOne.plan = value;

      this.formModel.errors.proposalPlanOne = null;
    },

    setProposalPlanTwo(value) {
      if (!this.remoteDTO.proposalPlanTwo)
        this.remoteDTO.proposalPlanTwo = {plan: value};
      else this.remoteDTO.proposalPlanTwo.plan = value;

      this.formModel.errors.proposalPlanTwo = null;
    },

    setProposalPlanThree(value) {
      if (!this.remoteDTO.proposalPlanThree)
        this.remoteDTO.proposalPlanThree = {plan: value};
      else this.remoteDTO.proposalPlanThree.plan = value;
      this.formModel.errors.proposalPlanThree = null;
    },

    setProposalPlanFour(value) {
      if (!this.remoteDTO.proposalPlanFour)
        this.remoteDTO.proposalPlanFour = {plan: value};
      else this.remoteDTO.proposalPlanFour.plan = value;
      this.formModel.errors.proposalPlanFour = null;
    },

    setProposalPlanFive(value) {
      if (!this.remoteDTO.proposalPlanFive)
        this.remoteDTO.proposalPlanFive = {plan: value};
      else this.remoteDTO.proposalPlanFive.plan = value;
      this.formModel.errors.proposalPlanFive = null;
    },

    async setParentId(value) {
      this.toogleDialogLoading(true);
      this.remoteDTO.parentId = value.id;
      const result = await service.get(value.id);
      this.formModel.parentPlan = result.data;
      this.toogleDialogLoading(false);
    },

    setMode(value) {
      this.formModel.mode = value;
      if (value == 'Novo') {
        this.remoteDTO.parentId = null;
        this.formModel.parentPlan = null;
      }
    },

    setActive(value) {
      this.remoteDTO.active = value;
    },

    save() {
      this.toogleDialogLoading(true);
      var result = this.remoteDTO.id
        ? service.update(this.remoteDTO)
        : service.save(this.remoteDTO);
      result
        .then((result) => {
          this.toogleDialogLoading(false);
          this.$router.push({
            name: 'plan_equiv_conf',
            params: {keyId: result.data.id},
          });
        })
        .catch((error) => {
          console.log(error);
          if (error.response && error.response.status == 400) {
            this.formModel.errors = mapFieldErrors(error.response.data.errors);
          } else {
            this.error = error;
            console.log(error);
          }
          this.toogleDialogLoading(false);
        });
    },

    edit(value) {
      this.$router.push({
        name: 'equiv_conf_edit',
        params: {keyId: this.remoteDTO.id},
      });
      this.mode = 'edit';
    },

    async remove(value) {
      this.toogleDialogLoading(true);
      if (
        await this.$refs.confirm.show(
          'Atenção',
          'Deseja excluir este registro?',
        )
      ) {
        await service.delete(this.remoteDTO.id);
        this.$router.push(
          `/equivalence_configuration/${this.$route.params.refPlanId}`,
        );
      } else {
        this.toogleDialogLoading(false);
      }
    },

    _fetchPlan(id) {
      return new Promise((resolve, reject) => {
        if (id) {
          productService
            .findByIdView(id)
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve({});
        }
      });
    },

    async fetchReferencePlan(id) {
      const data = await this._fetchPlan(id);
      this.remoteDTO.referencePlan = data;
    },
  },

  async created() {
    const path = this.$router.currentRoute.path;
    this.mode = path.substring(path.lastIndexOf('/') + 1);
    this.toogleDialogLoading(true);
    if (this.mode !== 'new') {
      this.remoteDTO.id = this.$route.params.keyId;
      const resp = await service.get(this.remoteDTO.id);
      this.remoteDTO.id = resp.data.id;
      this.remoteDTO.startAt = resp.data.startAt;
      this.remoteDTO.endAt = resp.data.endAt;
      this.remoteDTO.active = resp.data.active;
      this.remoteDTO.referencePlan = resp.data.referencePlan;
      this.remoteDTO.currentPlan = resp.data.currentPlan;
      this.remoteDTO.parentId = resp.data.parentId;
      this.remoteDTO.proposalPlanOne = resp.data.proposalPlanOne;
      this.remoteDTO.proposalPlanTwo = resp.data.proposalPlanTwo;
      this.remoteDTO.proposalPlanThree = resp.data.proposalPlanThree;
      this.remoteDTO.proposalPlanFour = resp.data.proposalPlanFour;
      this.remoteDTO.proposalPlanFive = resp.data.proposalPlanFive;
      if (this.remoteDTO.parentId) {
        this.formModel.mode = 'Herança';
        const response = await service.get(this.remoteDTO.parentId);
        this.formModel.parentPlan = response.data;
      }
    } else {
      const refPlanId = this.$route.params.refPlanId;
      const response = await productService.findByIdView(refPlanId);
      this.remoteDTO.referencePlan = response.data;
    }
    this.toogleDialogLoading(false);
  },
};
</script>

<style scoped>
</style>
